<template>
  <v-card flat>
    <v-card-text id="combinations-block" class="px-0">
      <v-card outlined>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-col v-if="!userData.is_single_property" cols="12" xs="12" md="12">
                <c-properties-autocomplete
                  dense
                  v-model="filters.property_id"
                  :label="$lang('quotes.filters.properties')"
                  :options="{
                    companyId: options.company_id
                  }"
                />
              </v-col>
              <!-- <v-col cols="12" md="3" xs="6">
                <v-date
                  dense
                  v-model="filters.start_date"
                  :min="$moment().format('YYYY-MM-DD')"
                  :label="$lang('main.words.from')"
                  scrollable
                  clearable
                  @input="refreshEndDate()"
                ></v-date>
              </v-col>
              <v-col cols="12" md="3" xs="6">
                <v-date
                  dense
                  v-model="filters.end_date"
                  :min="filters.start_date"
                  :label="$lang('main.words.to')"
                  scrollable
                  clearable
                ></v-date>
              </v-col>
              <v-col cols="12" md="3" xs="6">
                <v-text-field
                  dense
                  v-lazy-input:debounce="700"
                  v-model="filters.guests"
                  :label="$lang('quotes.fields.guests')"
                ></v-text-field>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="getData()" color="primary">
            {{ $lang('main.words.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-skeleton-loader
        v-show="request.loading"
        :tile="false"
        :boilerplate="false"
        type="heading,table-row-divider@15"
        class="mx-auto"
      ></v-skeleton-loader>

      <div v-if="!!collection.length && !request.loading">
        <v-card v-for="(property, c) in collection" class="mt-2" outlined :key="c">
          <v-card-title>{{ property.name }}</v-card-title>
          <v-card-text>
            <template v-for="(unit_category, i) in property.unit_categories">
              <v-row :key="`uc_${i}`">
                <v-col cols="12" xs="12" md="4">
                  <p class="text-h5">
                    {{ unit_category.name }}
                  </p>
                  <v-img
                    v-if="unit_category.main_image"
                    :src="unit_category.main_image.full_path"
                    width="100%"
                    contain
                  ></v-img>
                  <v-img
                    v-if="!unit_category.main_image"
                    width="100%"
                    src="/img/room.svg"
                    contain
                  ></v-img>
                  <div>
                    <v-chip
                      v-for="(amenity, am) in unit_category.amenities.slice(0, 5)"
                      :key="`am_${am}`"
                      small label
                      class="ma-1"
                    >
                      <v-icon small>{{amenity.icon}}</v-icon>
                      {{ $lang(`amenities.values.${amenity.key}`) }}
                    </v-chip>
                    <v-chip
                      v-if="unit_category.amenities.length > 5 && isShowExtraAmenities !== unit_category.id"
                      small label
                      class="ma-1"
                      color="primary"
                      @click="showExtraAmenities(unit_category.id)"
                    >...</v-chip>
                    <template v-if="isShowExtraAmenities === unit_category.id">
                      <v-chip
                        v-for="(amenity, am) in unit_category.amenities.slice(5)"
                        :key="`amp_${am}`"
                        small label
                        class="ma-1"
                        @click="hideExtraAmenities()"
                      >
                        <v-icon small>{{amenity.icon}}</v-icon>
                        {{ $lang(`amenities.values.${amenity.key}`) }}
                      </v-chip>
                    </template>
                  </div>
                </v-col>
                <v-col cols="12" xs="12" md="8">
                  <v-card v-for="(rate_plan, rp) in unit_category.rate_plans" :key="`rp_${rp}`" outlined class="my-1">
                    <v-card-text class="ma-0">
                      <v-row>
                        <v-col cols="12" xs="12" md="8">
                          <p class="title">
                            {{ rate_plan.name }}
                          </p>
                          <span v-if="rate_plan.is_refundable">
                            <p>
                              {{ $lang('rate-plans.fields.refundable_terms') }}:
                              {{ $constText('ConstRefundableTerms', rate_plan.refundable_terms) }}
                              <br>
                              {{ $lang('rate-plans.fields.refundable_penalty') }}:
                              {{ $constText('ConstRefundablePenalty', rate_plan.refundable_penalty) }}
                            </p>
                            <v-chip label class="mr-2" color="success" small>
                              {{ $lang('reservations.labels.refundable') }}
                            </v-chip>
                          </span>
                          <v-chip v-if="!rate_plan.is_refundable" label class="mr-2 my-1" color="error" small>
                            {{ $lang('reservations.labels.not_refundable') }}
                          </v-chip>
                          <v-chip label :color="mealPlanColor(rate_plan)" small class="my-1 text-uppercase white--text">
                            {{ $constText('ConstMealPlans', rate_plan.meal_plan) }}
                          </v-chip>
                        </v-col>
                        <v-col cols="12" xs="12" md="4" align="end">
                          <div>
                            <template v-for="(room_type, rt) in rate_plan.room_types">
                              <v-btn
                                v-if="room_type.unit_category_id === unit_category.id"
                                :key="`rt_${rt}`"
                                dense
                                block small
                                class="ma-2"
                                color="primary"
                                @click="select({ property, unit_category, room_type, rate_plan })"
                              >
                                <v-icon small>mdi-human-male</v-icon>x {{ room_type.guests }}
                                <span v-if="room_type.children">
                                  <v-icon small>mdi-baby-face-outline</v-icon>x {{ room_type.children }}
                                </span> |
                                {{ $money(calculateCombinationAmount({ property, unit_category, room_type }), property.currency) }}
                              </v-btn>
                            </template>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
            </template>
          </v-card-text>
        </v-card>
      </div>

      <v-col cols="12" align="center" v-if="!collection.length && !request.loading">
        <h2>{{ $lang('reservations.wizard.steps.solutions.no_records') }}</h2>
        <v-img width="300px" src="/img/planning.svg"></v-img>
        <v-btn @click="all" color="success">{{ $lang('reservations.wizard.show_unavailable') }}</v-btn>
      </v-col>

    </v-card-text>

    <scroll-loader :loader-method="more" v-if="pagination.page < pagination.totalPages">
    </scroll-loader>

  </v-card>
</template>

<script>
  import { mapState } from "vuex";

  import extraComputation from "@/pages/reservation-extras/mixins/extras-computation";

  import {
    GET_BOOKING_ENGINE_QUOTE_COMBINATIONS,
    GET_BOOKING_ENGINE_QUOTE_COMBINATIONS_RESET,
  } from "@/store/booking-engine/actions";

  export default {
    name: "Combinations",
    props: {
      options: {
        type: Object,
        required: false,
        default() {
          return {};
        }
      },
      searchFilters: {
        default() {
          return {};
        }
      }
    },
    mixins: [
      extraComputation,
    ],
    data() {
      return {
        filters: {
          all: false,
          guests: null,
          children: null,
          end_date: this.$toDateString(this.$moment().add(1, 'days')),
          start_date: this.$toDateString(this.$moment()),
          property_id: null,
        },
        selected: [],
        isShowExtraAmenities: null,
      }
    },
    mounted() {
      this.filters = {
        ...this.filters,
        ...this.options,
        property_ids: this.propertyIds,
      };

      this.$store.dispatch(GET_BOOKING_ENGINE_QUOTE_COMBINATIONS_RESET);
      this.getData();
    },
    methods: {
      getData(options) {
        options = options || {};

        this.$store.dispatch(GET_BOOKING_ENGINE_QUOTE_COMBINATIONS, {
          //limit: 3,
          page: this.pagination.page,
          perPage: this.pagination.perPage,
          ...this.filters,
          ...options,
        })
      },
      all() {
        this.getData({ all: true });
      },
      more() {
        this.getData({
          page: this.pagination.page + 1
        });

        this.request.loading = false;
      },
      calculateRoomTypeAmount(room_type) {
        let amount = 0;

        if (!room_type.rates || !room_type.rates.length) {
          return amount;
        }

        room_type.rates.map((rate) => {
          amount += parseFloat(rate.amount);
        });

        return amount;
      },
      calculateExtras({room_type, property}) {
        let requiredExtrasAmount = 0;
        let requiredExtras = [];

        property.extras.forEach(item => {
          let amount = this.computeAmount(item, {
            start_date: this.filters.start_date,
            end_date: this.filters.end_date,
            guests: room_type.guests,
          });

          requiredExtras.push({
            property_extra_id: item.id,
            name: item.name,
            amount: amount,
          })

          requiredExtrasAmount += amount;
        });

        return {
          amount: requiredExtrasAmount,
          extras: requiredExtras,
        }
      },
      calculateCombinationAmount(combination) {
        const roomTypeAmount = this.calculateRoomTypeAmount(combination.room_type);
        const cleaningFee = combination.unit_category.cleaning_fee ? combination.unit_category.cleaning_fee : 0;
        const requiredExtrasAmount = this.calculateExtras({
          room_type: combination.room_type,
          property: combination.property
        }).amount;

        return roomTypeAmount + cleaningFee + requiredExtrasAmount;
      },
      cancel() {
        this.$emit("cancel");
      },
      select({property, unit_category, room_type, rate_plan}) {
        this.$emit('selected', {
          room_type_id: room_type.id,
          property_id: property.id,
          company_id: property.company_id,
          amount_details: room_type.rates,
          cleaning_fee: unit_category.cleaning_fee ? unit_category.cleaning_fee : 0,
          guests: room_type.guests,
          is_refundable: room_type.refundable,
          meal_plan: room_type.meal_plan,
          summary: {
            property: property.name,
            currency: property.currency,
            unit_category: unit_category,
            room_type: room_type,
            rate_plan: rate_plan,
          }
        });
      },
      refreshEndDate() {
        let startDate = this.$moment(this.filters.start_date);
        let endDate = this.$moment(this.filters.end_date);

        if (endDate.isAfter(startDate)) {
          return;
        }

        this.filters.end_date = startDate.add(1, 'days').format('YYYY-MM-DD');
      },
      isSelected(id) {
        return this.selected.includes(id);
      },
      showExtraAmenities(id) {
        this.isShowExtraAmenities = id;
      },
      hideExtraAmenities() {
        this.isShowExtraAmenities = null;
      },
      mealPlanColor(item) {
        if (item.meal_plan === this.$const('ConstMealPlans', 'ROOM_ONLY')) {
          return 'error';
        }

        return 'success';
      }
    },
    computed: {
      collection() {
        return this.request.data.collection || [];
      },
      pagination() {
        if (!this.request.data.pagination) {
          return {
            page: 1,
            perPage: 3
          };
        }

        return this.request.data.pagination;
      },
      ...mapState({
        request: state => state.bookingEngine.getQuoteCombinationsRequest,
        propertyIds: state => state.settings.property.ids,
      }),
    }
  }
</script>
